import styled from 'styled-components';

// Previous/Next became buttons; drop the native button background so they match the page buttons.
export const PageNavButton = styled.button`
  background: none;
`;
